// extracted by mini-css-extract-plugin
export default {"boxContent":"styles_boxContent__QEPH1","text":"styles_text__FZSKy","boxImg":"styles_boxImg__tDwD-"};